import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useLoaderData, useNavigate } from 'react-router-dom'
import PageAppBar from 'components/PageAppBar'
import { ActivityModel } from 'types'
import ActivityDataGrid from 'components/ActivityDataGrid'

export default function ActivitiesPage() {
  const activities = useLoaderData() as ActivityModel[]
  const navigate = useNavigate()

  return (
    <PageAppBar pageName="Activités">
      <Box
        sx={{
          padding: '1rem',
          height: 'calc(100vh - 64px)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Button variant="contained" onClick={() => navigate('/activity')}>
            Créer une activité
          </Button>
        </Box>

        <Box sx={{ flexGrow: 1, width: '100%' }}>
          {/* --- UPDATED: Pass the filtered data to the DataGrid --- */}
          <ActivityDataGrid activities={activities} />
        </Box>
      </Box>
    </PageAppBar>
  )
}
